import { styled } from '@robocorp/theme';

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.$4};
  padding: ${({ theme }) => theme.space.$4};
  border-radius: ${({ theme }) => theme.radii.$8};
  background: ${({ theme }) => theme.colors.background.subtle.light.color};
  white-space: nowrap;
`;
